import { RateTableCarrier } from "@redotech/redo-fulfillment-outbound-labels-common/rate-table-carrier";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";
import { outboundWeightByZoneSchema } from "./rate-table";

export const CarriersToQuote = z
  .enum([
    RateTableCarrier.USPS,
    RateTableCarrier.UPS,
    RateTableCarrier.UPS_SUREPOST,
    RateTableCarrier.FEDEX,
    RateTableCarrier.DHL_ECS,
    RateTableCarrier.Amazon,
    RateTableCarrier.UNIUNI,
  ])
  .meta({ privacy: privacy.nonPii });

const carrierRateTablesSchema_ = z
  .object({
    fetchedAt: z.string().meta({ privacy: privacy.nonPii }),
    rateTables: z
      .partialRecord(
        CarriersToQuote.meta({ privacy: privacy.nonPii }),
        z
          .array(
            outboundWeightByZoneSchema.meta({ privacy: privacy.structured }),
          )
          .meta({ privacy: privacy.structured }),
      )
      .meta({ privacy: privacy.structured }),
  })
  .meta({ privacy: privacy.structured });

export const carrierRateTablesSchema: z.ZodType<RedoCarrierRateTables> =
  carrierRateTablesSchema_;
export interface RedoCarrierRateTables extends z.infer<
  typeof carrierRateTablesSchema_
> {}

export const CARRIER_RATE_TABLES_KEY = "CARRIER_RATE_TABLES";
